<template>
    <div v-if="visible" class="modal-overlay">
        <div class="modal-content">
            <h1>Progress</h1>
            <p>{{ message }}</p>
            <div
                class="progress-track"
                role="progressbar"
                :aria-valuemin="0"
                :aria-valuemax="100"
                :aria-valuenow="hasProgress ? percentage : undefined"
                aria-label="Loading progress"
            >
                <div v-if="hasProgress" class="progress-fill" :style="{ width: `${percentage}%` }"></div>
                <div v-else class="progress-indeterminate"></div>
            </div>
            <span v-if="hasProgress" class="progress-percent">{{ percentage }}%</span>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        message: {
            type: String,
            default: 'Loading...',
        },
        progress: {
            type: Number,
            default: null,
        },
    },
    computed: {
        hasProgress() {
            return Number.isFinite(this.progress);
        },
        percentage() {
            return Math.round(Math.max(0, Math.min(1, this.progress)) * 100);
        },
    },
    watch: {
        message: function () {
        },
    },
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background-color: rgba(2, 6, 23, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background-color: #1e293b;
    border: 1px solid rgba(148, 163, 184, 0.25);
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.45);
    padding: 20px;
    border-radius: 5px;
    color: #e2e8f0;
    text-align: center;
    min-width: 280px;
}

.modal-content h1 {
    margin: 0;
    color: #f8fafc;
}

.modal-content p {
    margin: 8px 0 0;
    color: #94a3b8;
}

.progress-track {
    position: relative;
    width: 100%;
    height: 8px;
    margin-top: 16px;
    overflow: hidden;
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.9);
}

.progress-fill,
.progress-indeterminate {
    height: 100%;
    border-radius: inherit;
    background: #38bdf8;
    transition: width 120ms ease-out;
}

.progress-indeterminate {
    width: 40%;
    animation: progress-indeterminate 1.2s ease-in-out infinite;
}

.progress-percent {
    display: block;
    margin-top: 8px;
    color: #94a3b8;
    font-size: 0.8rem;
}

@keyframes progress-indeterminate {
    from { transform: translateX(-125%); }
    to { transform: translateX(275%); }
}
</style>
